<template>
    <transition>
        <div class="container-fluid page-content">
            <!-- Header Row -->
            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center page-header-row gap-3 mb-4">
                <div>
                    <h4 class="page-title text-slate-800 fw-bold mb-1">Attributes</h4>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                            <li class="breadcrumb-item"><a href="/" class="text-muted"><i class="fas fa-home me-1"></i>Home</a></li>
                            <li class="breadcrumb-item"><a href="javascript:void(0);" class="text-muted">Master Settings</a></li>
                            <li class="breadcrumb-item active text-indigo fw-medium" aria-current="page">Attributes List</li>
                        </ol>
                    </nav>
                </div>
                <div>
                    <button type="button" class="btn btn-premium d-flex align-items-center gap-2" @click="toggleModal()">
                        <i class="fas fa-plus"></i> Add New Attribute
                    </button>
                </div>
            </div>

            <!-- Table Card -->
            <div class="card border-0 shadow-sm table-card">
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-premium mb-0" v-if="!loading && items.length > 0">
                            <thead>
                                <tr>
                                    <th style="width: 80px;">SL</th>
                                    <th>Title</th>
                                    <th>Status</th>
                                    <th class="text-end" style="width: 120px;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in items" :key="i">
                                    <td>{{ i + 1 }}</td>
                                    <td class="fw-bold text-slate-800">{{ item.title }}</td>
                                    <td>
                                        <span v-if="item.status == 1" class="badge-role badge-role-active">Active</span>
                                        <span v-if="item.status == 0" class="badge-role badge-role-inactive">Inactive</span>
                                    </td>
                                    <td class="text-end">
                                        <div class="dropdown d-inline-block">
                                            <button class="btn btn-action-dropdown dropdown-toggle arrow-none" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v"></i>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-end shadow-sm border-0">
                                                <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)">
                                                    <i class="fas fa-edit me-2"></i>Edit
                                                </a>
                                                <a href="javascript:void(0);" class="dropdown-item text-danger" @click="deleteItem(item)">
                                                    <i class="fas fa-trash-alt me-2"></i>Delete
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Empty State -->
                        <div class="text-center py-5" v-if="!loading && items.length === 0">
                            <div class="empty-state-icon mb-3">
                                <i class="fas fa-list text-muted fa-3x"></i>
                            </div>
                            <h5 class="text-slate-700 fw-bold">No Attributes Found</h5>
                            <p class="text-muted mb-0">Try adding a new attribute.</p>
                        </div>

                        <!-- Loading State -->
                        <div class="text-center py-5" v-if="loading">
                            <div class="spinner-premium mb-3 mx-auto"></div>
                            <h6 class="text-indigo fw-semibold">Loading data...</h6>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content border-0 shadow-lg modal-premium modal-premium-sm">
                    <div class="modal-header border-0 pb-0">
                        <h4 class="fw-bold m-0 text-slate-800">{{ editMode ? 'Update Attribute' : 'Create New Attribute' }}</h4>
                        <button @click="toggleModal()" type="button" class="btn-close-custom">✕</button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data">
                        <div class="modal-body py-4">
                            <div class="mb-3">
                                <label for="title" class="form-label-custom text-slate-700 fw-semibold mb-2">Attribute Title *</label>
                                <input type="text" class="form-control form-control-custom" :class="{'is-invalid': errors.title}" @keypress="onkeyPress('title')" v-model="form.title" id="title" placeholder="Enter attribute title" autocomplete="off">
                                <div class="invalid-feedback" v-if="errors.title">
                                    {{ errors.title[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer border-0 pt-0 justify-content-end gap-2">
                            <button type="button" class="btn btn-outline-premium px-4" @click="toggleModal()">Cancel</button>
                            <button type="submit" class="btn btn-premium px-4" :disabled="disabled">
                                <span v-show="isSubmit" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                {{ btn }}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    </transition>
</template>

<script>

import Modal from "../helper/Modal.vue";
import { ref, onMounted } from "vue";
import Form from "vform";
import axios from "axios";
export default {
    name: "PosLeftbar",
    components: {
        Modal
    },
    data() {
        return {
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            btn:'Create',
            loading: true,
            items: [],
            companies: [],
            form: new Form({
                id: '',
                title: '',
                status: 1,
            }),
        }
    },
    created() {
        this.fetchData(); 
    },

    methods: {
        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            console.log('this.modalActive', this.modalActive)
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset(); 
            console.log('then',this.isSubmit)
        },
        fetchData() { 
            axios.get(this.apiUrl+'/attributes', this.headerjson)
            .then((res) => { 
                this.items = res.data.data;
            })
            .finally((ress) => {
              this.loading = false; 
            });
        }, 

        edit: function(item) {
            this.toggleModal(); 
            this.btn='Update';
            this.editMode = true;
            
            this.form.fill(item); 
        },
        submitForm: function(e) { 
            
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();  
            formData.append('title', this.form.title);
            formData.append('status', this.form.status); 
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/attributes/'+this.form.id, formData, this.headers);
            }else{  
                var postEvent = axios.post(this.apiUrl+'/attributes', formData, this.headers);
            }           

            postEvent.then(res => {
                
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchData();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
                console.log(res.data)
            }).catch(err => {  
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            console.log('item delete=>',item.id);
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/attributes/'+item.id, this.headerjson)
                    .then(res => {
                        if(res.status == 200){ 
                            this.fetchData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                        console.log(res.data)
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },
    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>

<style scoped>
.modal-content.scrollbar-width-thin { 
    width: 600px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>